var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolcanoAshThickness({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.564 10-1.65 2.738 3.629 3.712-1.297-3.712.207-2.738h2.81L22 22H2l6.76-12h2.804zM13 8v1h-1V8h1zm-1-1v1h-1V7h1zm2-1v1h-1V6h1zm1-1v1h-1V5h1zm-5 0v1H9V5h1zm1-2v2h-1V3h1zm2 1v1h-1V4h1zm2-2v1h-1V2h1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolcanoAshThickness);
export default __webpack_public_path__ + "static/media/volcano_ash_thickness.237e6e6e467ebcfe4671880a2ea2a475.svg";
export { ForwardRef as ReactComponent };